import httpInstance from './http';
import { type AxiosRequestConfig } from 'axios';
import { type BaseResponse } from './config';

/**
 * 通用请求方法
 * @param config 请求配置
 * @returns Promise
 */
const request = <T = any>(config: AxiosRequestConfig): Promise<BaseResponse<T>> => {
  return httpInstance(config);
};

/**
 * GET请求
 * @param url 请求地址
 * @param params 请求参数
 * @param config 其他配置
 * @returns Promise
 */
export const get = <T = any>(
  url: string,
  params?: any,
  config?: AxiosRequestConfig
): Promise<BaseResponse<T>> => {
  return request<T>({
    method: 'GET',
    url,
    params,
    ...config
  });
};

/**
 * POST请求
 * @param url 请求地址
 * @param data 请求数据
 * @param config 其他配置
 * @returns Promise
 */
export const post = <T = any>(
  url: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<BaseResponse<T>> => {
  return request<T>({
    method: 'POST',
    url,
    data,
    ...config
  });
};

/**
 * PUT请求
 * @param url 请求地址
 * @param data 请求数据
 * @param config 其他配置
 * @returns Promise
 */
export const put = <T = any>(
  url: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<BaseResponse<T>> => {
  return request<T>({
    method: 'PUT',
    url,
    data,
    ...config
  });
};

/**
 * DELETE请求
 * @param url 请求地址
 * @param params 请求参数
 * @param config 其他配置
 * @returns Promise
 */
export const del = <T = any>(
  url: string,
  params?: any,
  config?: AxiosRequestConfig
): Promise<BaseResponse<T>> => {
  return request<T>({
    method: 'DELETE',
    url,
    params,
    ...config
  });
};

export default {
  get,
  post,
  put,
  del
};
